import * as toolbox from 'components/common/toolbox';
import AttachmentsTab from 'components/attachments/attachments-tab';
import Authorize from 'components/common/authorize';
import Badge from 'components/common/Badge';
import CatchErrors from 'components/common/catch-errors';
import InvoicesTab from 'components/invoices/invoices-tab';
import LineItems from 'components/line-items/line-items-tab/line-items';
import PaymentsTab from 'components/payments/payments-tab';
import React from 'react';
import _ from 'lodash';
import { PERMISSIONS, SERVICE_REQUEST_TERMS } from 'components/constants';
import { Route, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { numPanels } from 'components/common/toolbox';
import { useSelector } from 'react-redux';

export default function WorkOrderTabs(props) {

    const seg = 11;
    const match = useRouteMatch();
    const params = useParams();
    const history = useHistory();
    
    const service_request = useSelector((state) => state.serviceRequests.service_request);
    const user = useSelector(store => store.users?.user);
    const user_permissions = useSelector(store => store.users?.user_permissions);
    const workOrders = useSelector((store) => store.workOrders);
    const work_order = useSelector((store) => store.workOrders.work_order);

    const isServiceCall = (service_request?.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id);

    // Permissions ----------------------------------------

    const isTeamWO = (service_request?.techIds?.includes(user?.profileId) || service_request?.techIds?.includes(user?.email));
    const canView = (
        work_order?.technicianId == user?.profileId || 
        work_order?.ownerId == user?.email ||
        (isTeamWO && user_permissions[PERMISSIONS.WORK_ORDERS_TEAM_VIEW.key]) ||
        user_permissions[PERMISSIONS.WORK_ORDERS_VIEW.key]
    );
    const canEdit = (
        work_order?.technicianId == user?.profileId || 
        work_order?.ownerId == user?.email ||
        (isTeamWO && user_permissions[PERMISSIONS.WORK_ORDERS_TEAM_EDIT.key]) ||
        user_permissions[PERMISSIONS.WORK_ORDERS_EDIT.key]
    );
        
    // Functions ------------------------------------------
    
    const tab_active = (value) => {
        return (params.tab === value) ? ' active' : ''; // returns 'active' if value tab is active
    }
	const link_tab = (value, event) => {
		event.preventDefault();
		setTimeout(() => {
			history.replace(toolbox.modifyPath(props.location.pathname, seg, value, seg));
		}, 50);
	}

    return (
        <>
            <Route path={match.path} render={(route_props) =>
                <Authorize perm={ PERMISSIONS.WORK_ORDERS_VIEW } or={ canView }>
                    <div className="tabs-container mt-3">
                        <ul className={ `nav nav-tabs underline ${(numPanels(1))?'scroll-tabs':''}` } role="tablist">
                            <li className="position-relative">
                                <Badge type={'info'} number={workOrders?.work_order_items?.length || 0} />
                                <a className={'nav-link' + tab_active('items')} onClick={link_tab.bind(this, 'items')}>
                                    <i title="Line Items" className="fa-duotone fa-solid fa-list-ul fa-2x m-0"></i>
                                    <br />ITMS
                                </a>
                            </li>
                            { isServiceCall &&
                                <Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
                                    <li className="position-relative">
                                        <Badge type={'info'} number={service_request?.invoiceCount || 0} />
                                        <a className={'nav-link' + tab_active('invoices')} onClick={link_tab.bind(this, 'invoices')}>
                                            <i title="Invoices" className="fa-duotone fa-solid fa-file-lines fa-2x m-0"></i>
                                            <br />INV
                                        </a>
                                    </li>
                                </Authorize>
                            }
                            { isServiceCall &&
                                <Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_VIEW }>
                                    <li className="position-relative">
                                        <Badge type={'info'} number={service_request?.paymentCount || 0} />
                                        <a className={'nav-link' + tab_active('payments')} onClick={link_tab.bind(this, 'payments')}>
                                            <i title="Payments" className="fa-duotone fa-solid fa-file-invoice-dollar fa-2x m-0"></i>
                                            <br />PMT
                                        </a>
                                    </li>
                                </Authorize>
                            }
                            <li className="position-relative">
                                <Badge type={'info'} number={workOrders?.work_order_attachments?.length || 0} />
                                <a className={'nav-link' + tab_active('attachments')} onClick={link_tab.bind(this, 'attachments')}>
                                    <i title="Attachments" className="fa-duotone fa-solid fa-paperclip fa-2x m-0"></i>
                                    <br />ATT
                                </a>
                            </li>
                        </ul>

                        <div className="tab-content" style={{ marginBottom: '65px' }}>
                            <div role="tabpanel" className={'tab-pane' + tab_active('items')}>
                                <div className="panel-body">
                                    <Route path={match.path} render={(route_props) =>
                                        <CatchErrors>
                                            <LineItems {...route_props} source={'work-orders'} setFocused={ props.setFocused } permissions={{ canView, canEdit }} />
                                        </CatchErrors>
                                    } />
                                </div>
                            </div>
                            <div role="tabpanel" className={'tab-pane' + tab_active('invoices')}>
                                <div className="panel-body">
                                    <Route path={match.path} render={(route_props) =>
                                        <CatchErrors>
                                            <InvoicesTab {...route_props}
                                                prefix="SERVICE_REQUEST" 
                                                singular='service_request' 
                                                source='service-requests' 
                                                store="serviceRequests" 
                                            />
                                        </CatchErrors>
                                    } />
                                </div>
                            </div>
                            <div role="tabpanel" className={'tab-pane' + tab_active('payments')}>
                                <div className="panel-body">
                                    <Route path={match.path} render={(route_props) =>
                                        <CatchErrors>
                                            <PaymentsTab {...route_props} source='service-requests' />
                                        </CatchErrors>
                                    } />
                                </div>
                            </div>
                            <div role="tabpanel" className={'tab-pane' + tab_active('attachments')}>
                                <div className="panel-body">
                                    <Route path={match.path} render={(route_props) =>
                                        <CatchErrors>
                                            <AttachmentsTab {...route_props} 
                                                id={ params.work_order_id }
                                                name="Work Order" 
                                                permissions={{ canView, canEdit }}
                                                prefix="WORK_ORDER"
                                                singular="work_order" 
                                                source="work-orders" 
                                                store="workOrders" 
                                                setFocused={ props.setFocused }
                                            />
                                        </CatchErrors>
                                    } />
                                </div>
                            </div>
                        </div>
                    </div>
                </Authorize>
            } />
        </>
    );
};

